import { call, takeEvery, put } from "redux-saga/effects";
import Axios, { AxiosResponse } from "axios";
import { ServerResponse } from "http";
import {
  failure_api_call,
  success_api_call,
} from "./edit-general-setting-reducer";
import { isVariableStatement } from "typescript";
import { configs } from "../../common";

const api = configs.api + "/api4/update";

const getCall = (a: any) => {
  let token = localStorage.getItem("SpApperalsToken");
  return Axios.post(api, a.payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export function* EditGeneralSettingApi(e: any) {
  try {
    console.log(e);
    const response: AxiosResponse = yield call(getCall, e);

    yield put(success_api_call(response.data));
  } catch (e) {
    console.log(e);
    yield put(failure_api_call(e));
  }
}
